import { Controller } from "@hotwired/stimulus"

// A Prüfpunkt or the Gesamtergebnis of a UVV-Prüfung (custom_reports/fields/_inspection_item,
// _inspection_result): shows the reason for "nicht zutreffend", the Mangel part (description,
// safety tick, photos) and the lock choice of "nicht bestanden" only while they apply. The server
// decides on its own (CustomReports::InspectionAnswer); this is display only.
export default class extends Controller {
  static targets = ["status", "rating", "notApplicable", "reason", "defect", "result", "failed"]
  static values = { split: Boolean }

  connect() {
    this.refresh()
  }

  refresh() {
    const status = this.status()
    this.reasonTargets.forEach((el) => el.classList.toggle("hidden", status !== "not_applicable"))
    this.defectTargets.forEach((el) => el.classList.toggle("hidden", status !== "defect"))
    const result = this.resultTargets.find((input) => input.checked)?.value
    this.failedTargets.forEach((el) => el.classList.toggle("hidden", result !== "failed"))
  }

  status() {
    if (!this.splitValue) return this.statusTargets.find((input) => input.checked)?.value
    if (this.notApplicableTargets.some((input) => input.checked)) return "not_applicable"
    const ratings = this.ratingTargets.filter((input) => input.checked).map((input) => input.value)
    return ratings.includes("defect") ? "defect" : null
  }
}
